var map = {
	"./AcceptInvitationPortal.vue": [
		98757,
		2872,
		6172
	],
	"./AppRoot.vue": [
		51870,
		2639,
		2772,
		5875,
		1492,
		3322,
		1870
	],
	"./AssignmentAccessCodePortal.vue": [
		70492,
		492
	],
	"./AssignmentDetailPortal.vue": [
		62705,
		2705
	],
	"./BucketFileView.vue": [
		16203,
		6203
	],
	"./CustomTokenLoginView.vue": [
		26081,
		6081
	],
	"./DriveFileSelectView.vue": [
		35559,
		2872,
		208,
		5956
	],
	"./EnrollStudentView.vue": [
		7195,
		2872,
		5875,
		4118
	],
	"./ExtensionLogoutView.vue": [
		93654,
		3654
	],
	"./ExtensionUninstallSuccessView.vue": [
		74001,
		4001
	],
	"./ExtensionUninstallView.vue": [
		8883,
		8883
	],
	"./FreeFor2024View.vue": [
		28154,
		8154
	],
	"./GoogleLoginView.vue": [
		44667,
		4667
	],
	"./GoogleLoginWarningView.vue": [
		91143,
		1143
	],
	"./GoogleOauth2CallbackView.vue": [
		87044,
		2772,
		4889
	],
	"./IndependentStartView.vue": [
		1812,
		7229,
		798
	],
	"./LocalHostAuthView.vue": [
		28162,
		8162
	],
	"./LoginView.vue": [
		88061,
		8061
	],
	"./LogoutView.vue": [
		96027,
		2872,
		550
	],
	"./NewStudentView.vue": [
		26025,
		5875,
		6025
	],
	"./NewTeacherView.vue": [
		23436,
		5875,
		3436
	],
	"./NewUserView.vue": [
		20472,
		5875,
		472
	],
	"./NoteBoardShareView.vue": [
		44766,
		9417,
		7624,
		1976,
		2823,
		1031,
		337,
		8450,
		8330,
		4480
	],
	"./Oauth2CallbackView.vue": [
		1152,
		2772,
		1429
	],
	"./Oauth2LoginView.vue": [
		43129,
		3129
	],
	"./Oauth2LoginWarningView.vue": [
		34698,
		4698
	],
	"./PageNotFoundView.vue": [
		38173,
		5875,
		8173
	],
	"./RegisterPlatformView.vue": [
		15820,
		2639,
		4636,
		2772,
		5019,
		9364
	],
	"./RespondToAccessRequestView.vue": [
		12368,
		2368
	],
	"./StudentLogoutView.vue": [
		72775,
		2775
	],
	"./TeacherLogBackInView.vue": [
		87542,
		7542
	],
	"./TeacherTryForFreeRedirectView.vue": [
		91212,
		1212
	],
	"./TeacherTryForFreeView.vue": [
		20854,
		854
	],
	"./admin/AdminAssignmentsView.vue": [
		28048,
		4636,
		8048
	],
	"./admin/AdminEmailTestsView.vue": [
		18381,
		4636,
		8381
	],
	"./admin/AdminExtensionInstallationsView.vue": [
		39777,
		2639,
		4636,
		2772,
		5019,
		1353,
		9676,
		6329
	],
	"./admin/AdminMiscView.vue": [
		74267,
		4636,
		9417,
		7624,
		1976,
		2823,
		1031,
		4267
	],
	"./admin/AdminOrganizationsView.vue": [
		26490,
		2639,
		4636,
		2772,
		5019,
		9676,
		4842
	],
	"./admin/AdminRoot.vue": [
		67737,
		7737
	],
	"./admin/AdminUsersView.vue": [
		66394,
		2639,
		4636,
		2772,
		5019,
		9676,
		698
	],
	"./admin/components/AdminForcedExtensionUpdatePanel.vue": [
		65869,
		4636,
		5869
	],
	"./admin/components/AdminNav.vue": [
		13747,
		3747
	],
	"./admin/components/AssignmentConverter.vue": [
		18374,
		8374
	],
	"./admin/components/AssignmentDataLoader.vue": [
		87432,
		4636,
		7432
	],
	"./admin/components/BackFillNotePermissions.vue": [
		68370,
		8370
	],
	"./admin/components/CopyUser.vue": [
		92925,
		4636,
		2925
	],
	"./admin/components/DowngradeLoggerSessionsUtility.vue": [
		77149,
		4636,
		7149
	],
	"./admin/components/LoggerSessionBackFill.vue": [
		78528,
		8528
	],
	"./admin/components/ReloadUserDocumentFromRecord.vue": [
		1303,
		4636,
		1303
	],
	"./admin/components/TestAssignmentDetailInviteEmail.vue": [
		86334,
		4636,
		6334
	],
	"./admin/components/TestAssignmentDetailReportEmail.vue": [
		55567,
		4636,
		5567
	],
	"./admin/components/TestAssignmentReportEmail.vue": [
		72587,
		4636,
		2587
	],
	"./admin/components/TestClassifyText.vue": [
		25,
		4636,
		25
	],
	"./admin/components/TestCloudMessage.vue": [
		54481,
		4636,
		4481
	],
	"./admin/components/TestCloudMessageToStudents.vue": [
		49647,
		4636,
		9647
	],
	"./admin/components/TestCommandsHtml.vue": [
		91842,
		4636,
		9417,
		7624,
		1976,
		2823,
		1031,
		1842
	],
	"./admin/components/TestCourseInviteEmail.vue": [
		14288,
		4636,
		4288
	],
	"./admin/components/TestCreateInvitedUser.vue": [
		92891,
		4636,
		2891
	],
	"./admin/components/TestInstructorWelcomeEmail.vue": [
		53542,
		4636,
		3542
	],
	"./admin/components/TestLearnerWelcomeEmail.vue": [
		93790,
		4636,
		3790
	],
	"./admin/components/TestLearnicsUWelcomeEmail.vue": [
		77660,
		4636,
		7660
	],
	"./admin/components/TestLinkGoogleAccount.vue": [
		32309,
		4636,
		2309
	],
	"./admin/components/TestOrganizationInviteEmail.vue": [
		56876,
		4636,
		6876
	],
	"./admin/components/TestScheduledBucketFileCleanup.vue": [
		34164,
		4164
	],
	"./admin/components/TestSlackMessage.vue": [
		20575,
		575
	],
	"./admin/components/TestSlackMessageTeacherTryForFree.vue": [
		85970,
		5970
	],
	"./admin/components/TestUnlinkGoogleAccount.vue": [
		39440,
		4636,
		9440
	],
	"./assignmentForm/ClassroomAssignmentFormView.vue": [
		1949,
		2639,
		4636,
		2872,
		2772,
		431,
		9417,
		5875,
		7624,
		5019,
		1976,
		2823,
		1031,
		337,
		432,
		3985,
		69,
		9961,
		6424,
		6488,
		5650,
		9097,
		208,
		3191,
		8389,
		6879,
		3476,
		1590,
		782,
		1921,
		2437,
		1949
	],
	"./assignmentForm/LtiAssignmentFormView.vue": [
		70790,
		2639,
		4636,
		2872,
		2772,
		431,
		9417,
		5875,
		7624,
		5019,
		1976,
		2823,
		1031,
		337,
		432,
		3985,
		69,
		9961,
		6424,
		6488,
		5650,
		9097,
		208,
		3191,
		8389,
		6879,
		3476,
		1590,
		782,
		1921,
		2437,
		790
	],
	"./assignments/AssignmentPortal.vue": [
		13097,
		3097
	],
	"./assignments/AssignmentRoot.vue": [
		74761,
		5875,
		4761
	],
	"./assignments/components/ArchiveAssignmentDialog.vue": [
		83243,
		3243
	],
	"./assignments/components/AssignmentMissing.vue": [
		31510,
		5875,
		1510
	],
	"./assignments/components/AssignmentNoteBoardsList.vue": [
		56441,
		2639,
		4636,
		2872,
		2772,
		9417,
		7624,
		5019,
		1976,
		2823,
		1031,
		337,
		8661,
		8450,
		8330,
		1970,
		742,
		5481,
		8200,
		1999,
		4671
	],
	"./assignments/components/CategoriesTooltip.vue": [
		85440,
		5440
	],
	"./assignments/components/CategoryNode.vue": [
		25819,
		2639,
		1057,
		5998
	],
	"./assignments/components/CategoryUrlTable.vue": [
		25412,
		2639,
		1057,
		9241
	],
	"./assignments/components/CopyAssignmentDialog.vue": [
		40118,
		2639,
		4636,
		2872,
		2772,
		431,
		9417,
		5875,
		7624,
		5019,
		1976,
		2823,
		1031,
		337,
		432,
		3985,
		69,
		9961,
		6424,
		6488,
		5650,
		9097,
		208,
		3191,
		8389,
		6879,
		3476,
		1590,
		782,
		1921,
		2437,
		118
	],
	"./assignments/components/ExpectationsLegend.vue": [
		78342,
		5875,
		8342
	],
	"./assignments/components/ExpectationsPieChart.vue": [
		25295,
		7676
	],
	"./assignments/components/ExpectationsTable.vue": [
		75987,
		5875,
		5987
	],
	"./assignments/components/GoogleDriveFileIcon.vue": [
		84961,
		7342
	],
	"./assignments/components/MissingDataAlert.vue": [
		19627,
		9627
	],
	"./assignments/components/PieChart.vue": [
		62338,
		2338
	],
	"./assignments/components/RemoveUsersFromAssignmentConfirmDialog.vue": [
		42321,
		2872,
		8440
	],
	"./assignments/components/SearchDateItem.vue": [
		40221,
		221
	],
	"./assignments/components/SearchQuery.vue": [
		64809,
		4809
	],
	"./assignments/components/SearchStatistics.vue": [
		93084,
		3084,
		6977
	],
	"./assignments/components/StudentProgressReport.vue": [
		56763,
		431,
		5875,
		6763,
		9438
	],
	"./assignments/components/timeline/D3Timeline.vue": [
		71279,
		431,
		1279,
		5438
	],
	"./assignments/components/timeline/ScrollableTimeline.vue": [
		54988,
		2639,
		4636,
		2772,
		431,
		5019,
		1353,
		1279,
		4988,
		5467
	],
	"./assignments/components/timeline/SessionTimeline.vue": [
		9469,
		2639,
		4636,
		2772,
		431,
		5019,
		1353,
		1279,
		4988,
		9469,
		7476
	],
	"./assignments/components/timeline/SessionTimelineScrollbar.vue": [
		21476,
		1476
	],
	"./assignments/components/timeline/SessionTimelineTooltip.vue": [
		13928,
		1353,
		3928
	],
	"./assignments/student/StudentAssignmentPortal.vue": [
		92764,
		2764
	],
	"./assignments/student/StudentAssignmentRoot.vue": [
		8405,
		8723,
		831
	],
	"./assignments/student/start-assignment/MissingLearnicsExtensionView.vue": [
		13640,
		3640
	],
	"./assignments/student/start-assignment/ScheduledAssignmentView.vue": [
		14163,
		7499,
		4163
	],
	"./assignments/student/start-assignment/StartAssignmentRoot.vue": [
		23598,
		3598
	],
	"./assignments/student/start-assignment/StartAssignmentView.vue": [
		98491,
		2639,
		2872,
		7229,
		308,
		6229
	],
	"./assignments/student/start-assignment/components/EllipticalRecordText.vue": [
		46956,
		6956
	],
	"./assignments/student/start-assignment/components/MissingLearnicsExtension.vue": [
		60857,
		857
	],
	"./assignments/student/start-assignment/components/NoChromeExtensionDialog.vue": [
		97319,
		7319
	],
	"./assignments/student/start-assignment/components/OpenExtensionButton.vue": [
		83551,
		3551
	],
	"./assignments/student/start-assignment/components/OpenFullScreenButton.vue": [
		65670,
		5670
	],
	"./assignments/student/start-assignment/components/OpenPopupButton.vue": [
		55466,
		5466
	],
	"./assignments/student/start-assignment/components/OpenSidePanelButton.vue": [
		49643,
		9643
	],
	"./assignments/student/start-assignment/components/RecordButton.vue": [
		11441,
		7229,
		7217
	],
	"./assignments/student/start-assignment/components/RecordButtonIcon.vue": [
		87229,
		7229,
		3585
	],
	"./assignments/student/start-assignment/components/StudentInstructions.vue": [
		86259,
		2639,
		2872,
		7229,
		308,
		5615
	],
	"./assignments/student/start-assignment/components/StudentPopupInstructions.vue": [
		32136,
		2136
	],
	"./assignments/student/submissions/StudentAssignmentDataView.vue": [
		24450,
		2639,
		4636,
		2772,
		431,
		5875,
		5019,
		7499,
		1353,
		9676,
		1279,
		1057,
		9457,
		4988,
		3084,
		6763,
		9469,
		1720
	],
	"./assignments/student/submissions/StudentAssignmentDetailsView.vue": [
		21827,
		7499,
		1827
	],
	"./assignments/student/submissions/StudentAssignmentNoteBoardsView.vue": [
		93837,
		2639,
		4636,
		2872,
		2772,
		9417,
		7624,
		5019,
		1976,
		2823,
		1031,
		337,
		8661,
		8450,
		8330,
		1970,
		742,
		5481,
		8200,
		1999,
		4671,
		3837
	],
	"./assignments/student/submissions/StudentBibliographyView.vue": [
		29459,
		2639,
		4636,
		2872,
		2772,
		431,
		9417,
		5875,
		7624,
		5019,
		1976,
		2823,
		1031,
		337,
		432,
		3985,
		69,
		6424,
		6488,
		5650,
		9097,
		9897,
		6153,
		2159,
		7499,
		9936,
		7973,
		746,
		3979,
		4970,
		3233,
		2812,
		818,
		6658,
		8835
	],
	"./assignments/student/submissions/StudentSubmissionsPortal.vue": [
		36369,
		6369
	],
	"./assignments/student/submissions/StudentSubmissionsRoot.vue": [
		28223,
		2639,
		2772,
		3660
	],
	"./assignments/student/submissions/components/LoggingStatistics.vue": [
		24256,
		7499,
		4256
	],
	"./assignments/student/submissions/components/StudentAssignmentDetailsPanel.vue": [
		33186,
		2639,
		2772,
		4039
	],
	"./assignments/student/submissions/components/SubmissionDatesAndTimes.vue": [
		37247,
		7499,
		7247
	],
	"./assignments/teacher/TeacherAssignmentPortal.vue": [
		51676,
		1676
	],
	"./assignments/teacher/TeacherAssignmentRoot.vue": [
		4986,
		8723,
		4030
	],
	"./assignments/teacher/submissions/TeacherAssignmentDataView.vue": [
		41633,
		7499,
		9457,
		8473,
		8139
	],
	"./assignments/teacher/submissions/TeacherAssignmentDetailsView.vue": [
		42934,
		7499,
		2934
	],
	"./assignments/teacher/submissions/TeacherAssignmentExpectationsView.vue": [
		81969,
		2872,
		431,
		5875,
		6763,
		4379
	],
	"./assignments/teacher/submissions/TeacherAssignmentNoteBoardsView.vue": [
		39255,
		2639,
		4636,
		2872,
		2772,
		9417,
		7624,
		5019,
		1976,
		2823,
		1031,
		337,
		8661,
		8450,
		8330,
		1970,
		742,
		5481,
		8200,
		1999,
		4671,
		9255
	],
	"./assignments/teacher/submissions/TeacherAssignmentRosterView.vue": [
		19267,
		2639,
		4636,
		2872,
		431,
		7744,
		5964,
		6627
	],
	"./assignments/teacher/submissions/TeacherCategoriesOfSitesView.vue": [
		26988,
		2639,
		1057,
		8929
	],
	"./assignments/teacher/submissions/TeacherNotesTagsAnnotationsView.vue": [
		44590,
		2639,
		431,
		5658,
		9311,
		45,
		193,
		2566
	],
	"./assignments/teacher/submissions/TeacherOnlineActivityView.vue": [
		47980,
		7980
	],
	"./assignments/teacher/submissions/TeacherSearchesView.vue": [
		30233,
		3084,
		4441
	],
	"./assignments/teacher/submissions/TeacherSiteLogsView.vue": [
		28481,
		2639,
		4636,
		2772,
		5019,
		7499,
		9676,
		9457,
		6106
	],
	"./assignments/teacher/submissions/TeacherStudentWorkFilesView.vue": [
		84083,
		2639,
		2872,
		8661,
		5174,
		913
	],
	"./assignments/teacher/submissions/TeacherSubmissionsPortal.vue": [
		32797,
		2797
	],
	"./assignments/teacher/submissions/TeacherSubmissionsRoot.vue": [
		61114,
		2639,
		4636,
		2872,
		2772,
		431,
		9417,
		5875,
		7624,
		5019,
		1976,
		2823,
		1031,
		337,
		432,
		3985,
		69,
		9961,
		6424,
		6488,
		5650,
		9097,
		208,
		3191,
		8389,
		6879,
		3476,
		1590,
		782,
		1921,
		2437,
		7499,
		1239,
		4678
	],
	"./assignments/teacher/submissions/components/AssignmentReauthorizationHandler.vue": [
		7893,
		2872,
		1055
	],
	"./assignments/teacher/submissions/components/ContactingStudentLinksDialog.vue": [
		74277,
		4277
	],
	"./assignments/teacher/submissions/components/DriveFileIframeViewer.vue": [
		26948,
		2872,
		8661,
		9105
	],
	"./assignments/teacher/submissions/components/EditAssignment.vue": [
		17792,
		2639,
		4636,
		2872,
		2772,
		431,
		9417,
		5875,
		7624,
		5019,
		1976,
		2823,
		1031,
		337,
		432,
		3985,
		69,
		9961,
		6424,
		6488,
		5650,
		9097,
		208,
		3191,
		8389,
		6879,
		3476,
		1590,
		782,
		1921,
		2437,
		7792
	],
	"./assignments/teacher/submissions/components/GroupSiteDataSection.vue": [
		50193,
		2639,
		431,
		5658,
		9311,
		45,
		193,
		1165
	],
	"./assignments/teacher/submissions/components/IndividualNote.vue": [
		89311,
		2639,
		9311,
		929
	],
	"./assignments/teacher/submissions/components/IndividualSiteDataSection.vue": [
		20045,
		2639,
		431,
		5658,
		9311,
		45,
		1548
	],
	"./assignments/teacher/submissions/components/IndividualSiteDataSectionNotes.vue": [
		64824,
		2639,
		431,
		5658,
		9311,
		6680
	],
	"./assignments/teacher/submissions/components/ProgressPieChart.vue": [
		77007,
		9388
	],
	"./assignments/teacher/submissions/components/RouteScrollHook.vue": [
		3405,
		3405
	],
	"./assignments/teacher/submissions/components/SimpleTag.vue": [
		13127,
		3127
	],
	"./assignments/teacher/submissions/components/SitesByTimeChart.vue": [
		84805,
		4805
	],
	"./assignments/teacher/submissions/components/SitesByVisitChart.vue": [
		35876,
		5876
	],
	"./assignments/teacher/submissions/components/StudentByTimeBarChart.vue": [
		88473,
		8473,
		225
	],
	"./assignments/teacher/submissions/components/StudentCopyListItem.vue": [
		55174,
		2639,
		5174,
		1802
	],
	"./assignments/teacher/submissions/components/SubmissionsList.vue": [
		369,
		2639,
		2872,
		2772,
		431,
		5875,
		7499,
		8016
	],
	"./assignments/teacher/submissions/components/TeacherAssignmentDetailsPanel.vue": [
		81239,
		2639,
		4636,
		2872,
		2772,
		431,
		9417,
		5875,
		7624,
		5019,
		1976,
		2823,
		1031,
		337,
		432,
		3985,
		69,
		9961,
		6424,
		6488,
		5650,
		9097,
		208,
		3191,
		8389,
		6879,
		3476,
		1590,
		782,
		1921,
		2437,
		1239,
		9003
	],
	"./assignments/teacher/submissions/components/TeacherAssignmentLinks.vue": [
		89648,
		2639,
		2872,
		2772,
		5875,
		6836
	],
	"./assignments/teacher/submissions/components/TeacherNotesTagsAnnotations.vue": [
		24504,
		2639,
		431,
		5658,
		9311,
		45,
		193,
		1624
	],
	"./assignments/teacher/submissions/components/UserProfileDisplay.vue": [
		97094,
		7094
	],
	"./assignments/teacher/submissions/individual-student/IndividualStudentAiAndIntegrityView.vue": [
		37315,
		2639,
		4636,
		2772,
		5019,
		9676,
		55
	],
	"./assignments/teacher/submissions/individual-student/IndividualStudentDataView.vue": [
		17115,
		2639,
		4636,
		2772,
		431,
		5019,
		7499,
		1353,
		9676,
		1279,
		1057,
		9457,
		4988,
		3084,
		9469,
		8473,
		2845
	],
	"./assignments/teacher/submissions/individual-student/IndividualStudentNotesTagsAnnotationsView.vue": [
		78440,
		2639,
		431,
		5658,
		9311,
		2600
	],
	"./assignments/teacher/submissions/individual-student/IndividualStudentPortal.vue": [
		46915,
		6915
	],
	"./assignments/teacher/submissions/individual-student/IndividualStudentRoot.vue": [
		18332,
		9916,
		5241
	],
	"./assignments/teacher/submissions/individual-student/IndividualStudentVisualizationsView.vue": [
		31421,
		1421
	],
	"./assignments/teacher/submissions/individual-student/components/UserSiteDataSection.vue": [
		24786,
		2639,
		431,
		5658,
		9311,
		2258
	],
	"./components/AccessCodeFormModal.vue": [
		50510,
		4636,
		2872,
		70
	],
	"./components/AccessCodeInput.vue": [
		15147,
		4636,
		5147
	],
	"./components/AddClassroomAssignmentCard.vue": [
		45718,
		5718
	],
	"./components/AnimatedCheck.vue": [
		98048,
		5667
	],
	"./components/AppSpinner.vue": [
		48574,
		8574
	],
	"./components/AppVersion.vue": [
		48487,
		8487
	],
	"./components/AttachmentIcon.vue": [
		12700,
		2700
	],
	"./components/Auth.vue": [
		37383,
		2639,
		2772,
		5284
	],
	"./components/Breadcrumbs.vue": [
		64077,
		4077
	],
	"./components/CopyAccessCodeToClipboard.vue": [
		6183,
		2639,
		6183
	],
	"./components/CopyToClipboardButton.vue": [
		46007,
		2639,
		6007
	],
	"./components/FaviconImg.vue": [
		45682,
		5682
	],
	"./components/FreshDeskHelpButton.vue": [
		74879,
		4879
	],
	"./components/GoogleLoginButton.vue": [
		2580,
		2580
	],
	"./components/InstructorInvite.vue": [
		31941,
		4636,
		2872,
		5943
	],
	"./components/InstructorSelect.vue": [
		20782,
		2639,
		4636,
		2772,
		5019,
		782,
		6434
	],
	"./components/LearnicsSolidSpinner.vue": [
		49412,
		8661,
		9412
	],
	"./components/LoadingDialog.vue": [
		69195,
		2872,
		182
	],
	"./components/LtiTestStudentMessage.vue": [
		86834,
		6834
	],
	"./components/MasonTree.vue": [
		34804,
		431,
		5658,
		2423
	],
	"./components/MasonryLayout.vue": [
		62386,
		431,
		5658,
		2386
	],
	"./components/MicrosoftLoginButton.vue": [
		338,
		338
	],
	"./components/Navbar.vue": [
		33129,
		2639,
		2772,
		1492,
		3322
	],
	"./components/NavbarFooter.vue": [
		42709,
		2709
	],
	"./components/NavbarNotificationInvite.vue": [
		80598,
		2772,
		6503
	],
	"./components/NavbarNotifications.vue": [
		23703,
		2639,
		2772,
		1492,
		8658
	],
	"./components/PaywallBanner.vue": [
		47517,
		7517
	],
	"./components/PopupWrapper.vue": [
		46271,
		8652
	],
	"./components/ProfileImage.vue": [
		26698,
		6698
	],
	"./components/ResearchNotebookNote.vue": [
		73960,
		432,
		3985,
		69,
		6424,
		9897,
		6153,
		2159,
		5698
	],
	"./components/ResearchNotebookYProvider.vue": [
		41729,
		9897,
		1729
	],
	"./components/ResourceCard.vue": [
		85304,
		9916,
		9560
	],
	"./components/ResourceList.vue": [
		17823,
		7823
	],
	"./components/ResourceListItem.vue": [
		1429,
		2639,
		3810
	],
	"./components/ScrollableToolbar.vue": [
		11100,
		431,
		1100
	],
	"./components/SidePanelSymbol.vue": [
		9007,
		9007
	],
	"./components/SignInWithGoogleButton.vue": [
		93610,
		3610
	],
	"./components/SignInWithGoogleDialog.vue": [
		38593,
		8593
	],
	"./components/SmallScreenTestStudentMessage.vue": [
		62923,
		2923
	],
	"./components/TeacherIcon.vue": [
		63074,
		3074
	],
	"./components/VerticalCaret.vue": [
		15160,
		5160
	],
	"./components/assignmentForm/AssignmentForm.vue": [
		31735,
		2639,
		4636,
		2872,
		2772,
		431,
		9417,
		5875,
		7624,
		5019,
		1976,
		2823,
		1031,
		337,
		432,
		3985,
		69,
		9961,
		6424,
		6488,
		5650,
		9097,
		208,
		3191,
		8389,
		6879,
		3476,
		1590,
		782,
		1921,
		2437
	],
	"./components/assignmentForm/AssignmentFormPaywallModal.vue": [
		44387,
		4636,
		2872,
		4933
	],
	"./components/assignmentForm/AssignmentFormTagList.vue": [
		81033,
		2639,
		432,
		3985,
		6424,
		4453
	],
	"./components/assignmentForm/AssignmentOutlineForm.vue": [
		55957,
		2639,
		3985,
		69,
		5650,
		5107
	],
	"./components/assignmentForm/ClassroomCourseSelectableItem.vue": [
		4619,
		4619
	],
	"./components/assignmentForm/ClassroomCourseSelectableList.vue": [
		1104,
		1104
	],
	"./components/assignmentForm/CourseSelection.vue": [
		80899,
		2639,
		4636,
		2772,
		5019,
		8391
	],
	"./components/assignmentForm/DateTimeInput.vue": [
		19043,
		2639,
		4636,
		9043
	],
	"./components/assignmentForm/DescriptionInput.vue": [
		14297,
		4297
	],
	"./components/assignmentForm/InstructorsForm.vue": [
		41207,
		2639,
		4636,
		2772,
		5019,
		782,
		7024
	],
	"./components/assignmentForm/LimitedNumberInput.vue": [
		8760,
		4636,
		8760
	],
	"./components/assignmentForm/ScheduleDueDates.vue": [
		66271,
		2639,
		4636,
		6271
	],
	"./components/assignmentForm/SectionSelection.vue": [
		8052,
		2639,
		4636,
		2772,
		5019,
		6716
	],
	"./components/assignmentForm/SubmitAssignmentButton.vue": [
		22269,
		2639,
		2269
	],
	"./components/assignmentForm/WrongEmailErrorModal.vue": [
		14639,
		2872,
		7914
	],
	"./components/assignmentForm/advancedOptions/AdvancedOptionsForm.vue": [
		27590,
		2639,
		5875,
		7590
	],
	"./components/assignmentForm/attachments/AttachmentList.vue": [
		94238,
		2639,
		2772,
		431,
		432,
		9459
	],
	"./components/assignmentForm/attachments/AttachmentListItemTitle.vue": [
		2890,
		2772,
		8043
	],
	"./components/assignmentForm/attachments/AttachmentsForm.vue": [
		24761,
		2639,
		4636,
		2872,
		2772,
		431,
		9417,
		5875,
		7624,
		1976,
		2823,
		1031,
		337,
		432,
		9961,
		6488,
		9097,
		208,
		1921,
		5326
	],
	"./components/assignmentForm/attachments/LinkAttachmentForm.vue": [
		84302,
		4636,
		9417,
		5875,
		7624,
		1976,
		2823,
		1031,
		337,
		9961,
		6488,
		9097,
		1921,
		7113
	],
	"./components/assignmentForm/bibliography/BibliographyForm.vue": [
		39435,
		2639,
		4636,
		5875,
		9435
	],
	"./components/assignmentForm/expectations/AttachmentsExpectation.vue": [
		11764,
		2772,
		5697
	],
	"./components/assignmentForm/expectations/EditingGoogleDocsExpectation.vue": [
		85,
		2772,
		602
	],
	"./components/assignmentForm/expectations/ExpectationList.vue": [
		18691,
		4636,
		2772,
		431,
		3191,
		8389,
		6879,
		6376
	],
	"./components/assignmentForm/expectations/ExpectationListItem.vue": [
		96879,
		4636,
		2772,
		431,
		3191,
		8389,
		6879,
		958
	],
	"./components/assignmentForm/expectations/ExpectationsForm.vue": [
		44336,
		2639,
		4636,
		2872,
		2772,
		431,
		5875,
		9961,
		3191,
		8389,
		6879,
		3476,
		1590,
		1896
	],
	"./components/assignmentForm/expectations/ExternalUrlsExpectation.vue": [
		75996,
		4636,
		8389,
		5996
	],
	"./components/assignmentForm/expectations/PieChartInput.vue": [
		13191,
		431,
		3191,
		9807
	],
	"./components/assignmentForm/expectations/TimeRangeSlider.vue": [
		71590,
		4636,
		2872,
		5875,
		9961,
		3476,
		1590,
		5538
	],
	"./components/assignmentForm/expectations/TotalTimeForm.vue": [
		43476,
		4636,
		5875,
		9961,
		3476,
		1678
	],
	"./components/bibliography/AuthorsField.vue": [
		7444,
		2639,
		4636,
		2872,
		431,
		9417,
		5875,
		7624,
		746,
		9903
	],
	"./components/bibliography/BibliographyAnnotationManager.vue": [
		13233,
		2639,
		9417,
		7624,
		1976,
		432,
		3985,
		69,
		6424,
		9897,
		6153,
		2159,
		3233,
		2688
	],
	"./components/bibliography/BibliographyEditor.vue": [
		60818,
		2639,
		4636,
		2872,
		2772,
		431,
		9417,
		5875,
		7624,
		5019,
		1976,
		2823,
		1031,
		337,
		432,
		3985,
		69,
		6424,
		6488,
		5650,
		9097,
		9897,
		6153,
		2159,
		9936,
		7973,
		746,
		3979,
		4970,
		2205,
		3233,
		818,
		8012
	],
	"./components/bibliography/CitationEditor.vue": [
		86271,
		2639,
		4636,
		2872,
		2772,
		431,
		9417,
		5875,
		7624,
		5019,
		1976,
		432,
		3985,
		69,
		6424,
		5650,
		9897,
		6153,
		2159,
		746,
		4970,
		2205,
		3233,
		3775
	],
	"./components/bibliography/CitationField.vue": [
		22205,
		2639,
		431,
		9417,
		7624,
		2205,
		5084
	],
	"./components/bibliography/EditableCitationField.vue": [
		56765,
		431,
		9417,
		6765
	],
	"./components/bibliography/ElementsEditor.vue": [
		4970,
		2639,
		4636,
		2872,
		2772,
		431,
		9417,
		5875,
		7624,
		5019,
		3985,
		69,
		5650,
		746,
		4970,
		2739
	],
	"./components/bibliography/OldBibliographyEditor.vue": [
		26658,
		2639,
		4636,
		2872,
		2772,
		431,
		9417,
		5875,
		7624,
		5019,
		1976,
		2823,
		1031,
		337,
		3985,
		69,
		6488,
		5650,
		9097,
		7499,
		9936,
		746,
		4970,
		2205,
		2812,
		6658,
		8508
	],
	"./components/bibliography/OldCitationEditor.vue": [
		50431,
		2639,
		4636,
		2872,
		2772,
		431,
		9417,
		5875,
		7624,
		5019,
		3985,
		69,
		5650,
		746,
		4970,
		2205,
		2812,
		3256
	],
	"./components/noteboard/AddNoteBoardButton.vue": [
		14073,
		4073
	],
	"./components/noteboard/AppSpinner2.vue": [
		21632,
		8661,
		1632
	],
	"./components/noteboard/CollaborativeNoteBoardNote.vue": [
		31268,
		2639,
		9417,
		7624,
		1976,
		432,
		3985,
		69,
		6424,
		9897,
		6153,
		2159,
		1268,
		9773
	],
	"./components/noteboard/CreateNoteBoardDialog.vue": [
		41573,
		4636,
		2872,
		4727
	],
	"./components/noteboard/CreateNoteBoardForm.vue": [
		86899,
		4636,
		6899
	],
	"./components/noteboard/DeleteNoteBoardDialog.vue": [
		67967,
		2872,
		9417,
		7624,
		1976,
		2823,
		1031,
		337,
		8450,
		8330,
		9484
	],
	"./components/noteboard/EditableNoteBoardTitle.vue": [
		72375,
		9417,
		7624,
		1976,
		2823,
		1031,
		337,
		8450,
		8330,
		4961
	],
	"./components/noteboard/LeaveNoteBoardDialog.vue": [
		72875,
		2872,
		9417,
		7624,
		1976,
		2823,
		1031,
		337,
		8450,
		8330,
		5819
	],
	"./components/noteboard/LinkNotebookButton.vue": [
		51400,
		2872,
		2772,
		9417,
		5875,
		7624,
		1976,
		2823,
		1031,
		337,
		8450,
		8330,
		6122
	],
	"./components/noteboard/LoggerSessionSelectionDialog.vue": [
		25742,
		2872,
		2772,
		5875,
		5742,
		2650
	],
	"./components/noteboard/NewNoteButton.vue": [
		81816,
		1816
	],
	"./components/noteboard/NoNoteBoardNotesFoundPanel.vue": [
		71234,
		1234
	],
	"./components/noteboard/NoteBoardAccessRequestDialog.vue": [
		28226,
		8226
	],
	"./components/noteboard/NoteBoardAssignmentInviteDialog.vue": [
		25481,
		2872,
		2772,
		8661,
		1970,
		5481,
		1836
	],
	"./components/noteboard/NoteBoardBucketFileLoader.vue": [
		48020,
		8020
	],
	"./components/noteboard/NoteBoardCanvas.vue": [
		16966,
		2639,
		431,
		9417,
		7624,
		1976,
		432,
		3985,
		69,
		6424,
		9897,
		6153,
		2159,
		5658,
		1268,
		6966,
		2154
	],
	"./components/noteboard/NoteBoardCreateAccessRequestDialog.vue": [
		71951,
		2872,
		2922
	],
	"./components/noteboard/NoteBoardDragHandle.vue": [
		67156,
		7156
	],
	"./components/noteboard/NoteBoardDropSpotOverlay.vue": [
		6926,
		6926
	],
	"./components/noteboard/NoteBoardHeaderTrashDropSpot.vue": [
		85774,
		5774
	],
	"./components/noteboard/NoteBoardInvitationResponseDialog.vue": [
		10479,
		2872,
		3178
	],
	"./components/noteboard/NoteBoardInvitePanel.vue": [
		80742,
		2639,
		4636,
		2872,
		2772,
		9417,
		7624,
		5019,
		1976,
		2823,
		1031,
		337,
		8661,
		8450,
		8330,
		1970,
		742,
		7581
	],
	"./components/noteboard/NoteBoardInviteUsersButton.vue": [
		61921,
		2639,
		4636,
		2872,
		2772,
		9417,
		7624,
		5019,
		1976,
		2823,
		1031,
		337,
		8661,
		8450,
		8330,
		1970,
		742,
		5481,
		5893
	],
	"./components/noteboard/NoteBoardLayout.vue": [
		53005,
		2639,
		4636,
		2872,
		2772,
		431,
		9417,
		5875,
		7624,
		5019,
		1976,
		2823,
		1031,
		337,
		432,
		3985,
		69,
		6424,
		6488,
		8661,
		5650,
		8450,
		208,
		9897,
		8330,
		6153,
		2159,
		5658,
		1970,
		742,
		1268,
		9936,
		7973,
		3979,
		5388,
		4168,
		5390,
		6966,
		6046,
		2286
	],
	"./components/noteboard/NoteBoardListItem.vue": [
		88200,
		2639,
		2772,
		9417,
		8200,
		5221
	],
	"./components/noteboard/NoteBoardListView.vue": [
		79402,
		2639,
		9417,
		7624,
		1976,
		432,
		3985,
		69,
		6424,
		9897,
		6153,
		2159,
		1268,
		508
	],
	"./components/noteboard/NoteBoardMainPanel.vue": [
		96046,
		2639,
		4636,
		2872,
		2772,
		431,
		9417,
		7624,
		5019,
		1976,
		2823,
		1031,
		337,
		432,
		3985,
		69,
		6424,
		6488,
		5650,
		8450,
		208,
		9897,
		6153,
		2159,
		5658,
		1268,
		9936,
		7973,
		3979,
		5388,
		5390,
		6966,
		6046,
		7857
	],
	"./components/noteboard/NoteBoardNote.vue": [
		71039,
		432,
		3985,
		69,
		6424,
		9897,
		6153,
		2159,
		4921
	],
	"./components/noteboard/NoteBoardNoteLoader.vue": [
		9176,
		9176
	],
	"./components/noteboard/NoteBoardOneClickInviteDialog.vue": [
		51717,
		2639,
		4636,
		2872,
		2772,
		9417,
		7624,
		5019,
		1976,
		2823,
		1031,
		337,
		8661,
		8450,
		8330,
		1970,
		742,
		2017
	],
	"./components/noteboard/NoteBoardOutline.vue": [
		5390,
		2639,
		2872,
		2772,
		9417,
		7624,
		1976,
		432,
		3985,
		69,
		6424,
		5650,
		9897,
		6153,
		2159,
		1268,
		5390,
		2583
	],
	"./components/noteboard/NoteBoardOutlineEditingNote.vue": [
		5085,
		2639,
		9417,
		7624,
		1976,
		432,
		3985,
		69,
		6424,
		9897,
		6153,
		2159,
		1268,
		7477
	],
	"./components/noteboard/NoteBoardOutlineExport.vue": [
		68557,
		2639,
		4636,
		2872,
		2772,
		9417,
		7624,
		5019,
		1976,
		2823,
		1031,
		337,
		6488,
		8450,
		208,
		9936,
		7973,
		3979,
		5388,
		1824,
		9806
	],
	"./components/noteboard/NoteBoardOutlineExportDocx.vue": [
		5388,
		2639,
		4636,
		2872,
		2772,
		9417,
		7624,
		5019,
		1976,
		2823,
		337,
		8450,
		5388,
		6142
	],
	"./components/noteboard/NoteBoardOutlineExportGoogleDocs.vue": [
		81824,
		2639,
		4636,
		2872,
		2772,
		9417,
		7624,
		5019,
		1976,
		2823,
		1031,
		337,
		6488,
		208,
		1824,
		6321
	],
	"./components/noteboard/NoteBoardResearchNotebookLoader.vue": [
		61222,
		9897,
		6153,
		6952
	],
	"./components/noteboard/NoteBoardSearch.vue": [
		65030,
		4636,
		431,
		5030
	],
	"./components/noteboard/NoteBoardSessionLoader.vue": [
		7034,
		7034
	],
	"./components/noteboard/NoteBoardTagFilter.vue": [
		84356,
		2639,
		431,
		4356
	],
	"./components/noteboard/NoteBoardTrashButton.vue": [
		77585,
		7585
	],
	"./components/noteboard/NoteBoardTrashPanel.vue": [
		96717,
		2639,
		2872,
		431,
		9417,
		7624,
		1976,
		432,
		3985,
		69,
		6424,
		9897,
		6153,
		2159,
		5658,
		1268,
		4302
	],
	"./components/noteboard/NoteBoardUserList.vue": [
		28944,
		2639,
		2872,
		2772,
		9417,
		7624,
		1976,
		2823,
		1031,
		337,
		8450,
		8330,
		4168,
		5431
	],
	"./components/noteboard/NoteBoardUserTag.vue": [
		4168,
		2639,
		2872,
		2772,
		9417,
		7624,
		1976,
		2823,
		1031,
		337,
		8450,
		8330,
		4168,
		4360
	],
	"./components/noteboard/NoteBoardWrapper.vue": [
		35902,
		2639,
		4636,
		2872,
		2772,
		431,
		9417,
		5875,
		7624,
		5019,
		1976,
		2823,
		1031,
		337,
		432,
		3985,
		69,
		6424,
		6488,
		8661,
		5650,
		8450,
		208,
		9897,
		8330,
		6153,
		2159,
		5658,
		1970,
		742,
		1268,
		9936,
		7973,
		3979,
		5388,
		4168,
		5390,
		6966,
		6046,
		1103
	],
	"./components/noteboard/NoteBoardsList.vue": [
		65205,
		2639,
		4636,
		2872,
		2772,
		9417,
		7624,
		5019,
		1976,
		2823,
		1031,
		337,
		8661,
		8450,
		8330,
		1970,
		742,
		5481,
		8200,
		1999,
		2567
	],
	"./components/noteboard/OutlineExportForm.vue": [
		52737,
		2639,
		4636,
		2772,
		5019,
		4689
	],
	"./components/noteboard/RemoveNoteBoardUserDialog.vue": [
		3521,
		2872,
		9417,
		7624,
		1976,
		2823,
		1031,
		337,
		8450,
		8330,
		8598
	],
	"./components/noteboard/SelectedNoteBoardNoteTrashControls.vue": [
		45331,
		2872,
		7838
	],
	"./components/noteboard/SiteFaviconWithTooltip.vue": [
		72694,
		2639,
		2694
	],
	"./components/noteboard/TipTapNoteBoardNote.vue": [
		65052,
		5052
	],
	"./components/noteboard/TipTapNoteBoardNoteContents.vue": [
		70731,
		2639,
		9417,
		7624,
		1976,
		432,
		3985,
		69,
		6424,
		9897,
		6153,
		2159,
		1268,
		5295
	],
	"./components/noteboard/TipTapNoteBoardNotePlaceholder.vue": [
		74163,
		6544
	],
	"./components/noteboard/TransferNoteBoardOwnershipDialog.vue": [
		28906,
		2872,
		1467
	],
	"./components/roleIcons/AdministratorIcon.vue": [
		34736,
		4736
	],
	"./components/roleIcons/InstructorIcon.vue": [
		79108,
		9108
	],
	"./components/roleIcons/LearnerIcon.vue": [
		88439,
		8439
	],
	"./components/rosterTable/AddUsersButton.vue": [
		97744,
		4636,
		2872,
		7744,
		899
	],
	"./components/rosterTable/PageControls.vue": [
		35994,
		5994
	],
	"./components/rosterTable/ResourceRoster.vue": [
		65964,
		2639,
		4636,
		2872,
		431,
		7744,
		5964,
		6916
	],
	"./components/rosterTable/UserRolesTableCell.vue": [
		98677,
		8677
	],
	"./components/rosterTable/UserRolesTableHeaderColumn.vue": [
		75605,
		5605
	],
	"./courses/CourseAssignmentsRoot.vue": [
		97869,
		7869
	],
	"./courses/CourseAssignmentsView.vue": [
		47325,
		2639,
		4636,
		2872,
		2772,
		431,
		9417,
		5875,
		7624,
		5019,
		1976,
		2823,
		1031,
		337,
		432,
		3985,
		69,
		9961,
		6424,
		6488,
		5650,
		9097,
		208,
		3191,
		8389,
		6879,
		3476,
		1590,
		782,
		1921,
		2437,
		4201,
		5098,
		5835
	],
	"./courses/CoursePortal.vue": [
		30254,
		254
	],
	"./courses/CourseRoot.vue": [
		25574,
		9916,
		9326
	],
	"./courses/CourseRosterView.vue": [
		20491,
		2639,
		4636,
		2872,
		431,
		7744,
		5964,
		4411
	],
	"./courses/CourseSectionsRoot.vue": [
		16266,
		6266
	],
	"./courses/CourseSectionsView.vue": [
		45751,
		2639,
		4636,
		2872,
		5875,
		9961,
		7671,
		4794,
		9636
	],
	"./courses/CourseSettingsView.vue": [
		96883,
		2639,
		4636,
		2872,
		2772,
		5019,
		9961,
		8589
	],
	"./courses/components/AddSection.vue": [
		92722,
		4636,
		2872,
		5875,
		9961,
		6058
	],
	"./courses/components/ArchiveCourseDialog.vue": [
		3449,
		3449
	],
	"./courses/components/AssignmentListItem.vue": [
		4201,
		2639,
		4636,
		2872,
		2772,
		431,
		9417,
		5875,
		7624,
		5019,
		1976,
		2823,
		1031,
		337,
		432,
		3985,
		69,
		9961,
		6424,
		6488,
		5650,
		9097,
		208,
		3191,
		8389,
		6879,
		3476,
		1590,
		782,
		1921,
		2437,
		4201,
		2779
	],
	"./courses/components/CourseAddAssignment.vue": [
		25098,
		2639,
		4636,
		2872,
		2772,
		431,
		9417,
		5875,
		7624,
		5019,
		1976,
		2823,
		1031,
		337,
		432,
		3985,
		69,
		9961,
		6424,
		6488,
		5650,
		9097,
		208,
		3191,
		8389,
		6879,
		3476,
		1590,
		782,
		1921,
		2437,
		5098,
		6579
	],
	"./courses/components/CourseAssignmentList.vue": [
		98980,
		2639,
		4636,
		2872,
		2772,
		431,
		9417,
		5875,
		7624,
		5019,
		1976,
		2823,
		1031,
		337,
		432,
		3985,
		69,
		9961,
		6424,
		6488,
		5650,
		9097,
		208,
		3191,
		8389,
		6879,
		3476,
		1590,
		782,
		1921,
		2437,
		4201,
		5098,
		900
	],
	"./courses/components/SectionForm.vue": [
		14713,
		4636,
		5875,
		9961,
		4713
	],
	"./courses/components/SectionList.vue": [
		24794,
		2639,
		4636,
		2872,
		5875,
		9961,
		7671,
		4794,
		5534
	],
	"./courses/components/SectionListItem.vue": [
		57671,
		2639,
		7671,
		2981
	],
	"./noteBoard/NoteBoardPortal.vue": [
		94043,
		8661,
		4043
	],
	"./noteBoard/NoteBoardRoot.vue": [
		37652,
		8661,
		7652
	],
	"./noteBoard/NoteBoardView.vue": [
		1025,
		2639,
		4636,
		2872,
		2772,
		431,
		9417,
		5875,
		7624,
		5019,
		1976,
		2823,
		1031,
		337,
		432,
		3985,
		69,
		6424,
		6488,
		8661,
		5650,
		8450,
		208,
		9897,
		8330,
		6153,
		2159,
		5658,
		1970,
		742,
		1268,
		9936,
		7973,
		3979,
		5388,
		4168,
		5390,
		6966,
		6046,
		9194
	],
	"./noteBoards/NoteBoardRouteContainer.vue": [
		89033,
		8661,
		9033,
		7031
	],
	"./noteBoards/NoteBoardsPortal.vue": [
		42460,
		8661,
		9033,
		2715
	],
	"./noteBoards/NoteBoardsRoot.vue": [
		50804,
		8661,
		9033,
		3291
	],
	"./noteBoards/NoteBoardsSessionCreateView.vue": [
		63691,
		4636,
		2872,
		2772,
		5875,
		5742,
		4694
	],
	"./noteBoards/NoteBoardsSessionPortal.vue": [
		67566,
		8661,
		7566
	],
	"./noteBoards/NoteBoardsSessionRoot.vue": [
		82740,
		8661,
		9033,
		5301
	],
	"./noteBoards/NoteBoardsSessionSelectView.vue": [
		95933,
		2639,
		4636,
		2872,
		2772,
		431,
		9417,
		7624,
		5019,
		1976,
		2823,
		1031,
		337,
		8661,
		8450,
		8330,
		5658,
		1970,
		742,
		5481,
		8200,
		1999,
		3
	],
	"./noteBoards/NoteBoardsSessionsRoot.vue": [
		88246,
		8246
	],
	"./noteBoards/NoteBoardsView.vue": [
		1505,
		2639,
		4636,
		2872,
		2772,
		9417,
		5875,
		7624,
		5019,
		1976,
		2823,
		1031,
		337,
		8661,
		8450,
		8330,
		1970,
		742,
		5481,
		8200,
		1999,
		9033,
		5742,
		4983
	],
	"./organizations/CoursesRoot.vue": [
		11146,
		1146
	],
	"./organizations/CoursesView.vue": [
		52060,
		2639,
		4636,
		2872,
		2772,
		5875,
		5019,
		432,
		9961,
		8661,
		9916,
		968,
		1138,
		6692,
		3511,
		7871
	],
	"./organizations/OrganizationRoot.vue": [
		44719,
		9916,
		4601
	],
	"./organizations/OrganizationRosterView.vue": [
		62807,
		2639,
		4636,
		2872,
		431,
		7744,
		5964,
		6935
	],
	"./organizations/OrganizationSettingsView.vue": [
		79773,
		4636,
		9961,
		4535
	],
	"./organizations/OrganizationsRoot.vue": [
		10767,
		767
	],
	"./organizations/OrganizationsView.vue": [
		15315,
		2639,
		9916,
		447,
		3429
	],
	"./organizations/components/AddCourse.vue": [
		67570,
		4636,
		2872,
		5875,
		9961,
		5562
	],
	"./organizations/components/AddCourseButton.vue": [
		82323,
		2639,
		4636,
		2872,
		2772,
		5875,
		5019,
		432,
		9961,
		8661,
		9916,
		968,
		1138,
		2323
	],
	"./organizations/components/ArchiveOrganizationDialog.vue": [
		48849,
		8849
	],
	"./organizations/components/CourseList.vue": [
		13511,
		2639,
		4636,
		2872,
		2772,
		5875,
		5019,
		432,
		9961,
		8661,
		9916,
		968,
		1138,
		6692,
		3511,
		1920
	],
	"./organizations/components/CourseListItem.vue": [
		16692,
		2639,
		6692,
		7255
	],
	"./organizations/components/GoogleClassroomCourses.vue": [
		34070,
		2639,
		2872,
		2772,
		5875,
		6934
	],
	"./organizations/components/OrganizationForm.vue": [
		69280,
		4636,
		5875,
		9961,
		9280
	],
	"./organizations/components/OrganizationList.vue": [
		41622,
		2639,
		447,
		9250
	],
	"./organizations/components/OrganizationListItem.vue": [
		10447,
		2639,
		447,
		9333
	],
	"./organizations/components/RemoveUsersFromOrgConfirmDialog.vue": [
		53094,
		2872,
		3463
	],
	"./organizations/components/RemoveUsersFromResourceConfirmDialog.vue": [
		96389,
		2872,
		4335
	],
	"./organizations/components/UpgradeCourseForm.vue": [
		52677,
		4636,
		9961,
		2677
	],
	"./organizations/components/courseForm/CourseForm.vue": [
		99517,
		2639,
		4636,
		2872,
		2772,
		5875,
		5019,
		432,
		9961,
		8661,
		9916,
		968,
		1138
	],
	"./organizations/components/courseForm/ImportFromClassroomForm.vue": [
		20968,
		5875,
		8661,
		968,
		9224
	],
	"./organizations/components/courseForm/SectionItem.vue": [
		48780,
		4636,
		9961,
		8780
	],
	"./organizations/components/courseForm/SectionSymbol.vue": [
		44292,
		4292
	],
	"./popups/CustomTokenAuthView.vue": [
		74916,
		4916
	],
	"./popups/CustomTokenSignInView.vue": [
		39490,
		9490
	],
	"./popups/ExtensionErrorView.vue": [
		25278,
		5278
	],
	"./popups/ExtensionErrorView2.vue": [
		83778,
		3778
	],
	"./popups/GetCustomTokenView.vue": [
		4082,
		4082
	],
	"./popups/LoadCustomTokenView.vue": [
		6473,
		6473
	],
	"./popups/LocalHostSignInView.vue": [
		81477,
		1477
	],
	"./popups/PopupsRoot.vue": [
		67615,
		7615
	],
	"./popups/StoppedLoggingAssignmentView.vue": [
		29679,
		2060
	],
	"./popups/StoppedLoggingMessageView.vue": [
		16413,
		6413
	],
	"./popups/assignment/AssignmentPopupRoot.vue": [
		29148,
		9148
	],
	"./popups/assignment/InstructorStopLoggingView.vue": [
		89780,
		9780
	],
	"./popups/session/ExportBibliographyView.vue": [
		69522,
		9417,
		7624,
		1976,
		2823,
		1031,
		337,
		6488,
		9097,
		9522
	],
	"./popups/session/ExportNotesView.vue": [
		31577,
		9417,
		7624,
		1976,
		2823,
		1031,
		337,
		6488,
		3958
	],
	"./popups/session/SessionPopupRoot.vue": [
		59100,
		9100
	],
	"./popups/session/SleepStopLoggingView.vue": [
		35293,
		5293
	],
	"./popups/session/components/DocsExporter.vue": [
		33763,
		3763
	],
	"./sections/SectionAssignmentsRoot.vue": [
		21494,
		1494
	],
	"./sections/SectionAssignmentsView.vue": [
		68877,
		2639,
		4636,
		2872,
		2772,
		431,
		9417,
		5875,
		7624,
		5019,
		1976,
		2823,
		1031,
		337,
		432,
		3985,
		69,
		9961,
		6424,
		6488,
		5650,
		9097,
		208,
		3191,
		8389,
		6879,
		3476,
		1590,
		782,
		1921,
		2437,
		4201,
		4370,
		2243
	],
	"./sections/SectionRoot.vue": [
		87093,
		9916,
		3031
	],
	"./sections/SectionRosterView.vue": [
		45514,
		2639,
		4636,
		2872,
		431,
		7744,
		5964,
		8328
	],
	"./sections/SectionSettingsView.vue": [
		50254,
		2639,
		4636,
		2872,
		2772,
		5019,
		9961,
		2376
	],
	"./sections/components/ArchiveSectionDialog.vue": [
		35692,
		5692
	],
	"./sections/components/SectionAddAssignment.vue": [
		64370,
		2639,
		4636,
		2872,
		2772,
		431,
		9417,
		5875,
		7624,
		5019,
		1976,
		2823,
		1031,
		337,
		432,
		3985,
		69,
		9961,
		6424,
		6488,
		5650,
		9097,
		208,
		3191,
		8389,
		6879,
		3476,
		1590,
		782,
		1921,
		2437,
		4370,
		3499
	],
	"./sections/components/SectionAssignmentList.vue": [
		78407,
		2639,
		4636,
		2872,
		2772,
		431,
		9417,
		5875,
		7624,
		5019,
		1976,
		2823,
		1031,
		337,
		432,
		3985,
		69,
		9961,
		6424,
		6488,
		5650,
		9097,
		208,
		3191,
		8389,
		6879,
		3476,
		1590,
		782,
		1921,
		2437,
		4201,
		4370,
		8277
	],
	"./sessions/OldSessionBibliographyView.vue": [
		12365,
		2639,
		4636,
		2872,
		2772,
		431,
		9417,
		5875,
		7624,
		5019,
		1976,
		2823,
		1031,
		337,
		3985,
		69,
		6488,
		5650,
		9097,
		7499,
		9936,
		746,
		4970,
		2205,
		2812,
		6658,
		9424
	],
	"./sessions/SessionBibliographyView.vue": [
		36407,
		2639,
		4636,
		2872,
		2772,
		431,
		9417,
		5875,
		7624,
		5019,
		1976,
		2823,
		1031,
		337,
		432,
		3985,
		69,
		6424,
		6488,
		5650,
		9097,
		9897,
		6153,
		2159,
		9936,
		7973,
		746,
		3979,
		4970,
		2205,
		3233,
		818,
		6470
	],
	"./sessions/SessionRoot.vue": [
		61330,
		8723,
		3782
	],
	"./sessions/SessionView.vue": [
		23361,
		3361
	],
	"./sessions/SessionsRoot.vue": [
		8897,
		8897
	],
	"./sessions/SessionsView.vue": [
		25634,
		5634
	],
	"./studentReport/StudentReportRoot.vue": [
		46640,
		6640
	],
	"./studentReport/StudentReportView.vue": [
		95877,
		431,
		1353,
		6249,
		354
	],
	"./studentReport/components/CustomPieChart.vue": [
		79334,
		431,
		6953
	],
	"./studentReport/components/CustomPieChartWithKey.vue": [
		76249,
		431,
		6249,
		7710
	],
	"./studentReport/components/LearnicsSnapshotTitle.vue": [
		96466,
		6466
	],
	"./studentReport/components/PercentageChartKey.vue": [
		4631,
		4631
	],
	"./studentReport/components/ReportDetailList.vue": [
		96964,
		6964
	],
	"./studentReport/components/ReportGenerationError.vue": [
		6542,
		6542
	],
	"./studentReport/components/ReportPieChart.vue": [
		92095,
		2095
	],
	"./studentReport/components/ReportSitesTable.vue": [
		8242,
		8242
	],
	"./u/LearnicsUPaymentPortalView.vue": [
		28582,
		8582
	],
	"./u/LearnicsURoot.vue": [
		13905,
		3905
	],
	"./u/LearnicsUTermsOfServiceView.vue": [
		65724,
		5724
	],
	"./u/LearnicsUTourView.vue": [
		3856,
		3856
	],
	"./u/components/LearnicsUTermsOfService.vue": [
		45004,
		5004
	],
	"./u/components/LearnicsUTourStep1.vue": [
		72011,
		2011
	],
	"./u/components/LearnicsUTourStep2.vue": [
		96978,
		6978
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 94235;
module.exports = webpackAsyncContext;